module.exports = __webpack_public_path__ + "static/conferencia-banner-607b21c2ac9027f3d683eaf7504a36a1.jpeg";